import React, { useEffect, useState } from 'react';
import { urlAddNotification, urlLogOut } from '../URLlist/urlList';
import './header.css';

// import * as Notifications from "expo-notifications";

import { IoMenu } from 'react-icons/io5';
import { IoMdLogOut } from 'react-icons/io';

import { IoCloseCircleOutline } from 'react-icons/io5';
import { sortProps } from '../../views/home/home';

import SortBy from '../sortSerch/SortBy';
import SearchItem from '../sortSerch/SearchItem';
import NewDate from '../newDate/newDate';
import { propsMassage } from '../massage/massage';
import { useCookies } from 'react-cookie';
import { saveConsoleLog } from '../../helpFunction/helpFunction';
import { QueryNotifications } from '../queryNotififation/QueryNotifications';

interface props {
  setRefresh: (e: boolean) => void;
  refresh: boolean;
  setMassage: (e: propsMassage) => void;
  setSpinner: (e: boolean) => void;
  setSort: (e: sortProps) => void;
  setSearch: (e: string) => void;
  search: string;
}

type notififacionAllow = 'ALLOW' | 'FORBIDEN';

function Header({ setRefresh, refresh, setMassage, setSpinner, setSort, setSearch, search }: props) {
  const [stateAdd, setStateAdd] = useState<boolean>(false);
  const [menu, setMenu] = useState(false);
  const [isChecked, setChecked] = useState<boolean>(false);
  const [showQueryNotification, setShowQueryNotification] = useState<boolean>(false);
  const [cookies, setCookie, removeCookie] = useCookies(['notification', 'notificationAllow']);

  useEffect(() => {
    if (cookies.notificationAllow === 'ALLOW') {
      setChecked(true);
    } else {
      setChecked(false);
    }
  }, [cookies.notificationAllow]);

  function addClick() {
    setStateAdd(true);
  }

  const logOut = async () => {
    await fetch(urlLogOut, {
      credentials: 'include',
    });
    setRefresh(!refresh);
  };
  const menuShow = async () => {
    setMenu(true);
  };
  const menuClose = async () => {
    setMenu(false);
  };

  const showQueryNotificationDiv = () => {
    if (isChecked) {
      setShowQueryNotification(true);
    } else {
      addNotificationToken();
    }
  };
  const removeNotificationToken = async () => {
    saveConsoleLog(`remove Token z app: ${cookies.notification}`);
    setCookie('notificationAllow', 'FORBIDEN', { maxAge: 12 * 30 * 24 * 60 * 60 * 1000 });

    try {
      await fetch(urlAddNotification, {
        credentials: 'include',
        method: 'delete',
      });
    } catch (error) {}
    return;
  };
  const addNotificationToken = async () => {
    try {
      setCookie('notificationAllow', 'ALLOW', { maxAge: 12 * 30 * 24 * 60 * 60 * 1000 });
      await fetch(urlAddNotification, {
        credentials: 'include',
        method: 'post',
        body: JSON.stringify({ notificationToken: cookies.notification }),
        headers: {
          'Content-Type': 'application/json',
        },
      });
    } catch (error) {}
    saveConsoleLog(`Add Token z app: ${cookies.notification}`);
    setChecked(true);
    return;
  };

  return (
    <>
      <div className={'header'}>
        {!menu && (
          <>
            <div className='menuObrys' onClick={menuShow}>
              <IoMenu className='iconMenu' name={'menu'} size={30} />
            </div>

            <div className='headerTitel'>
              <div className='containerImg'>
                <img alt='logo' srcSet={require('./../../assets/newLogoSmall.png')} className='headerImg' />
              </div>

              <div className='headerDivButtons'>
                {!stateAdd && (
                  <>
                    <div onClick={addClick}>
                      <p className='headerButton'>Dodaj nową date</p>
                    </div>
                  </>
                )}
              </div>
            </div>
            <div className='headerSortSerch'>
              <SortBy setSort={setSort} />
              <SearchItem setSearch={setSearch} search={search} />
            </div>
            {stateAdd && <NewDate setRefresh={setRefresh} newDateVisible={setStateAdd} refresh={refresh} setMassage={setMassage} setSpinner={setSpinner} changeImage={false} />}
          </>
        )}

        {menu && (
          <>
            <div className='headerMenuShow'>
              <div className='menuSectionAll'>
                <div className='sectionCloseLogOut'>
                  <div className='menuClose' onClick={menuClose}>
                    <IoCloseCircleOutline size={25} color='#900' />
                    <p>MENU</p>
                  </div>

                  <div className='logOut' onClick={logOut}>
                    <IoMdLogOut size={25} color='#900' onClick={logOut} />

                    <p>WYLOGUJ</p>
                  </div>
                </div>

                <div className='sectionChackBox' onClick={() => showQueryNotificationDiv()}>
                  <input type='checkbox' title='check' className='checkbox' checked={isChecked} onChange={() => showQueryNotificationDiv()}></input>
                  <p className='sectionChackBoxText'>Powiadomienia o nadchodzących urodzinach</p>
                </div>
                {showQueryNotification && <QueryNotifications removeNotificationToken={removeNotificationToken} setShowQueryNotification={setShowQueryNotification} />}
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
}

export default Header;
